import React, { createContext, useState } from 'react';

export const SelectedCompanyContext = createContext({ selected:null, setSelected:()=>{} });

export const SelectedCompanyProvider = ({ children }) => {
  const [selected, setSelected] = useState(null);
  return (
    <SelectedCompanyContext.Provider value={{selected,setSelected}}>
      {children}
    </SelectedCompanyContext.Provider>
  );
}; 